// @ts-ignore Box is re-exported from @theme-ui/components.
import { Box as X } from 'theme-ui';
export default X;
// Not sure why this no longer compiles, but it doesn't.
// /**
//  * @template Type
//  * @type {typeof import('./ThemeUI').Box} */
//  const Box = X;
//  export default Box;
//# sourceMappingURL=Box.js.map